// @format

import "bootstrap";
import "bootstrap-select";

let pageshowBound = false;

export function initSelectpicker(): void {
  $(document).ready(function () {
    $(".selectpicker, .selectpickerr").each(function () {
      const $el = $(this);
      if ($el.data("selectpicker")) {
        $el.selectpicker("refresh");
      } else {
        $el.selectpicker();
      }
    });
  });
  // destroySelectpicker();


  if (!pageshowBound) {
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        $(".selectpicker, .selectpickerr").each(function () {
          const $el = $(this);
          if ($el.data("selectpicker")) {
            $el.selectpicker("refresh");
          } else {
            $el.selectpicker();
          }
        });
      }
    });
    pageshowBound = true;
  }
}

export function destroySelectpicker(): void {
  $(".selectpicker, .selectpickerr").selectpicker("destroy");
}
